import cn from 'classnames';
import logoName from '@assets/svg/logo-name.svg';
import logo from '@assets/svg/logo.svg';
import { NavLink, Link } from 'react-router-dom';
import { EXTRAS_LINKS, GAMES_LINKS } from '@consts/ui';
import styles from './navigation.module.scss';

export interface INavigationMenuProps {
  isVisibleInMobile: boolean;
  // openDepositAndWithdrawal: () => void;
  openWithdrawModal: () => void;
  className?: string;
}

const NavigationMenu = ({ isVisibleInMobile, openWithdrawModal, className = '' }: INavigationMenuProps): JSX.Element => {
  /* ClassNames */

  const navbarClassNames = cn(styles.nav, className, {
    [styles.open]: isVisibleInMobile,
  });

  const linkClassNames = ({ isActive }: { isActive: boolean }) => cn(styles.link, { [styles.active]: isActive });

  /* Components */

  const gamesLinks = GAMES_LINKS.map((link) => (
    <NavLink key={link.path} to={link.path} className={linkClassNames}>
      {link.name}
    </NavLink>
  ));

  const extrasLinks = EXTRAS_LINKS.map((link) => (
    <NavLink key={link.path} to={link.path} className={styles.link}>
      {link.name}
    </NavLink>
  ));

  return (
    <nav className={navbarClassNames}>
      <div className={styles.nav__wrapper}>
        <Link to='/'>
          <img src={logo} className={styles.mobileLogo} alt='' />
        </Link>

        <Link to='/' className={cn(styles.logo, 'desktop')}>
          <img src={logo} className={styles.logo__img} alt='' />
          <img src={logoName} className={styles.logo__name} alt='' />
        </Link>

        <div className={styles.links}>
          <div className={styles.divider} />
          <h6 className={styles.heading}>Games</h6>
          {gamesLinks}

          <div className={styles.divider} />

          <h6 className={styles.heading}>Extras</h6>
          {extrasLinks}
        </div>
      </div>

      <button className={styles.withdraw} onClick={openWithdrawModal}>
        Support
      </button>
    </nav>
  );
};

export default NavigationMenu;
